import React from 'react'
import './testimonials.css'

import Avatar from '../../assets/avatar.png'

// import Swiper core and required modules
import { EffectCards  } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import "swiper/css/effect-cards";


const data =[
  {
    avatar:Avatar,
    name:'Tina Snow',
    review:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum unde, adipisci non beatae deserunt, nostrum c umque sequi tempora odit, magni magnam quidem placeat atque! Sapiente quod maxime maiores vitae aut?'
  },
  {
    avatar:Avatar,
    name:'Mizan Rahi',
    review:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum unde, adipisci non beatae deserunt, nostrum c umque sequi tempora odit, magni magnam quidem placeat atque! Sapiente quod maxime maiores vitae aut?'
  },
  {
    avatar:Avatar,
    name:'Jose',
    review:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum unde, adipisci non beatae deserunt, nostrum c umque sequi tempora odit, magni magnam quidem placeat atque! Sapiente quod maxime maiores vitae aut?'
  },
  {
    avatar:Avatar,
    name:'Jamal Edward',
    review:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum unde, adipisci non beatae deserunt, nostrum c umque sequi tempora odit, magni magnam quidem placeat atque! Sapiente quod maxime maiores vitae aut?'
  },
  {
    avatar:Avatar,
    name:'Zeeshan Siddique',
    review:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum unde, adipisci non beatae deserunt, nostrum c umque sequi tempora odit, magni magnam quidem placeat atque! Sapiente quod maxime maiores vitae aut?'
  },
  {
    avatar:Avatar,
    name:'Shatta Wale',
    review:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum unde, adipisci non beatae deserunt, nostrum c umque sequi tempora odit, magni magnam quidem placeat atque! Sapiente quod maxime maiores vitae aut?'
  },
]

function Testimonials() {
  return (
    <section>
      <h5>Review From Clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container test_container"
            effect={"cards"}
            grabCursor={true}
            modules={[EffectCards]}
           
            
      
      >
      {  data.map(({avatar,name,review},index)=>{
          return(
            <SwiperSlide key={index} className="test">
          <div className="client_avatar">
            <img src={avatar} alt="" />
            
          </div>
          <h5 className='name'>{name}</h5>
            <small className='review'>{review}</small>
        </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}

export default Testimonials